import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import {LogOut} from 'lucide-react';
export default function LogoutButton() {

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('GF_User_Data');
        window.location.reload()
    };


    return (
        <button onClick={handleLogout} className="btn btn-primary m-2 d-flex align-items-center gap-2 mt-auto">
            <LogOut size={20} />
            Logout
        </button>
    )
}
